import ShowAllArchivedClietns from "../components/ShowAllArchivedClietns";
import NavBarComponent from '../components/NavBarComponent';

function AllArchivedClients() {
  return (
    <>
      <NavBarComponent />
      <ShowAllArchivedClietns />
    </>
  );
}

export default AllArchivedClients;